module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/notokr-light.woff
// module id = GkM2
// module chunks = 0